import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'date-range-friendly',
  templateUrl: './date-range-friendly.component.html',
})
export class DateRangeFriendlyComponent implements OnInit {
  @Input() start: Date;
  @Input() end?: Date;

  public isToday: boolean;
  public isSameDay: boolean;
  public isOngoing: boolean;

  constructor() { }

  ngOnInit() {
    const today = new Date();

    const startClone = new Date(this.start.getTime());

    if (!this.end) {
      this.isOngoing = true;

      this.isToday = today.setHours(0, 0, 0, 0) === startClone.setHours(0, 0, 0, 0);
      this.isSameDay = this.isToday;

    } else {
      const endClone = new Date(this.end.getTime());

      this.isToday = today.setHours(0, 0, 0, 0) === endClone.setHours(0, 0, 0, 0);
      this.isSameDay = startClone.setHours(0, 0, 0, 0) === endClone.setHours(0, 0, 0, 0);
    }
  }
}
